require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./truncatedtext"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./truncatedtext"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./truncatedtext")) : factory(root["./utils"], root["./truncatedtext"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__17__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[33],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(317);


/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Label = _interopRequireDefault(__webpack_require__(318));

exports["default"] = _Label["default"];
exports.Label = _Label["default"];

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _Label = _interopRequireDefault(__webpack_require__(66));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var labelClassName = _Label["default"].labelClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;
var resolveBaseTextDir = _utils.bidiUtils.resolveBaseTextDir;

var Label = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Label, _Component);

  function Label() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Label.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        textDir = _this$props.textDir,
        numShape = _this$props.numShape,
        label = _this$props.label,
        ellipsis = _this$props.ellipsis,
        disabled = _this$props.disabled,
        hover = _this$props.hover,
        active = _this$props.active,
        htmlFor = _this$props.htmlFor,
        className = _this$props.className,
        style = _this$props.style,
        location = _this$props.location,
        truncatedTextExtraOptions = _this$props.truncatedTextExtraOptions,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["textDir", "numShape", "label", "ellipsis", "disabled", "hover", "active", "htmlFor", "className", "style", "location", "truncatedTextExtraOptions"]);
    var classNames = (0, _utils.classnames)(labelClassName, {
      disabled: disabled,
      active: active,
      hover: hover
    });
    var inner = ellipsis ? /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-label__truncated-text"
    }, sanitize(truncatedTextExtraOptions, Label), {
      value: label,
      location: location,
      textDir: textDir,
      numShape: numShape
    })) : _utils.Bidi.reshape(label, numShape);

    if (htmlFor) {
      return /*#__PURE__*/_react["default"].createElement("label", (0, _extends2["default"])({
        dir: resolveBaseTextDir(label, textDir, false)
      }, sanitize(others, Label), {
        className: classNames + " " + className,
        htmlFor: htmlFor,
        style: style
      }), inner);
    }

    return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
      dir: resolveBaseTextDir(label, textDir, false)
    }, sanitize(others, Label), {
      className: classNames + " " + className,
      style: style
    }), inner);
  };

  return Label;
}(_react.Component);

exports["default"] = Label;
(0, _defineProperty2["default"])(Label, "propTypes", {
  label: _propTypes["default"].string.isRequired,
  ellipsis: _propTypes["default"].bool,
  htmlFor: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  hover: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  location: _propTypes["default"].oneOf(['end', 'middle']),
  style: _propTypes["default"].object,
  truncatedTextExtraOptions: _propTypes["default"].object,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  numShape: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Label, "defaultProps", {
  className: '',
  style: {},
  truncatedTextExtraOptions: {},
  textDir: ''
});

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(67);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-label{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;display:inline-block;margin:0;user-select:none;cursor:default}.ba-common-label.is-disabled{cursor:not-allowed}.ba-common-label.is-disabled .ba-common-truncatedText{cursor:inherit}.ba--highContrast .ba-common-label.is-disabled{cursor:not-allowed;text-decoration:line-through}.ba-common-label{transition:opacity .2s ease-in-out;color:#161616}.ba-common-label.is-disabled{color:#c6c6c6}\n", ""]);

// exports
exports.locals = {
	"labelClassName": "\"ba-common-label\""
};

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[316,0]]]);
});